import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-mcq-general-placement-answer',
  templateUrl: './add-mcq-general-placement-answer.component.html',
  styleUrls: ['./add-mcq-general-placement-answer.component.scss']
})
export class AddMcqGeneralPlacementAnswerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
